export default [false, false, true, true, false];